import swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';

export function showInformationAlert(
  title,
  text,
  confirmButtonText,
  showCancelButton,
  callbackFunction
) {
  const cb = callbackFunction;
  swal({
    title,
    text,
    type: "info",
    showCancelButton,
    cancelButtonText: "Cancel",
    confirmButtonClass: "btn-danger",
    confirmButtonColor: "#2e5965",
    confirmButtonText,
  }).then((result) => {
    cb(result.value);
  });
}

/**
 * Show sweetalert2 warning modal
 * @param title {String} Modal title
 * @param text {String} Modal text
 * @param callback {Function|undefined} Optional callback to be executed after closing modal
 */
export function showWarningAlert(title, text, callback) {
  swal({
    type: "warning",
    title,
    text,
    onClose: () => {
      if (callback) callback();
    },
  });
}

// content = {title, text, btn_no, btn_yes}
export function showActionConfirmation(content, callbackFunction) {
  const cb = callbackFunction;
  swal({
    title: content.title,
    text: content.text,
    type: "question",
    showCancelButton: true,
    cancelButtonText: content.btn_no,
    cancelButtonColor: "#2e5965",
    confirmButtonClass: "btn-danger",
    confirmButtonColor: "#2e5965",
    confirmButtonText: content.btn_yes,
    allowEscapeKey: false,
    allowOutsideClick: false,
  }).then((result) => {
    cb(result.value);
  });
}

export function showQuickConfirmation(content) {
  let timerInterval;
  swal({
    html: `<h5>${content.title}</h5>`,
    timer: content.timer,
    showConfirmButton: false,
    onClose: () => {
      clearInterval(timerInterval);
    },
  });
}

export function showErrorAlert(title, html, callback) {
  swal({
    type: "error",
    title,
    html,
    confirmButtonColor: "#f27474",
    onClose: () => {
      if (callback) callback();
    },
  });
}

export function showRenewalDateErrorAlert(title, html, callback) {
  swal({
    type: "error",
    title,
    html,
    confirmButtonColor: "#f27474",
    onClose: () => {
      if (callback) callback();
    },
  });
}

export function showAlertMessage(type, title, callback) {
  let color = "#0ba133";
  if (type === "success") {
    color = "#0ba133";
  } else if (type === "info") {
    color = "#66c2ff";
  } else if (type === "warning") {
    color = "#ffa560";
  } else if (type === "error") {
    color = "#f05e5e";
  }
  swal({
    type,
    title:`<h2 style="color:${color}">${title}</h2>`,
    onClose: () => {
      if (callback) callback();
    },
  });
}

export function showToastSuccessNotification(successMsg) {
  toast.success(successMsg, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });
}
const selectionModalValues = {};
export function showSelectionModal({
  title,
  description,
  label,
  options = [],
  placeholder = '--Select--',
  errorMessage = 'Please select an option.',
  confirmButtonText = 'Yes',
  cancelButtonText = 'No',
  confirmButtonColor = '#2e5965',
  cancelButtonColor = '#dd3333',
  selectId = 'selectionModal',
  onConfirm,
}) {
  const formOptions = options
    .map(
      option =>
        `<option value="${option.value}" ${
          String(option.value) === String(selectionModalValues[selectId] || '')
            ? 'selected'
            : ''
        } style="white-space:normal;overflow-wrap:anywhere;word-break:break-word;max-width:100%">
          ${option.label}
        </option>`
    )
    .join('');

  const errorIcon = `
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f05e5e" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>`;

  swal({
    title,
    html: `
      <p>${description}</p>

      <div class="sc-row-field-wrapper" style="width:100%;max-width:100%">
        <div class="formItem" style="width:100%;max-width:100%;min-width:0">
          <label for="${selectId}" style="font-weight:500;margin-bottom:8px;display:block">
            ${label}
          </label>

          <div style="position:relative;width:100%;max-width:100%;min-width:0">
            <select
              id="${selectId}"
              class="formSelect"
              style="
                width:100%;
                max-width:100%;
                min-width:0;
                padding:10px 50px 10px 12px;
                border:1px solid #d1d5db;
                border-radius:6px;
                font-size:14px;
                color:#111827;
                background-color:#fff;
                appearance:none;
                -webkit-appearance:none;
                -moz-appearance:none;
                cursor:pointer;
                outline:none;
                white-space:normal;
                overflow-wrap:anywhere;
                word-break:break-word;
              "
            >
              <option value="">${placeholder}</option>
              ${formOptions}
            </select>

            <!-- Custom dropdown arrow -->
            <div
              style="
                position:absolute;
                top:1px;
                right:1px;
                width:38px;
                height:calc(100% - 2px);
                display:flex;
                align-items:center;
                justify-content:center;
                background:#f3f4f6;
                border-left:1px solid #d1d5db;
                border-top-right-radius:6px;
                border-bottom-right-radius:6px;
                pointer-events:none;
                z-index:999;
              "
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#4b5563"
                stroke-width="2.75"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
          </div>

          <div
            id="${selectId}Error"
            style="display:none;margin-top:6px;color:#f05e5e;font-size:12px;align-items:center;gap:4px"
          >
            ${errorIcon}
            ${errorMessage}
          </div>
        </div>
      </div>
    `,
    type: 'warning',
    showCancelButton: true,
    cancelButtonText,
    cancelButtonColor,
    confirmButtonColor,
    confirmButtonText,
    allowEscapeKey: true,
    allowOutsideClick: true,

    onOpen() {
      const modal = document.querySelector('.swal2-modal');
      if (!modal) return;

      const select = modal.querySelector(`#${selectId}`);
      const error = modal.querySelector(`#${selectId}Error`);
      const confirmBtn = modal.querySelector('.swal2-confirm');

      if (!select || !error || !confirmBtn) return;

      const updateState = () => {
        const invalid = !select.value;

        confirmBtn.disabled = invalid;
        confirmBtn.style.opacity = invalid ? '0.5' : '1';
        confirmBtn.style.cursor = invalid ? 'not-allowed' : 'pointer';

        error.style.display = invalid ? 'flex' : 'none';
      };

      updateState();

      select.addEventListener('change', () => {
        selectionModalValues[selectId] = select.value;
        updateState();
      });
    }
  }).then(result => {
    if (result.value !== true) return;

    const select = document.querySelector(`#${selectId}`);
    const selectedValue = select ? parseInt(select.value, 10) : null;

    if (selectedValue > 0 && onConfirm) {
      onConfirm(selectedValue);
    }
  });
}

export function showConfirmModal(title, text, confirmButtonText, showCancelButton, callbackFunction) {
  swal({
    title,
    text,
    type: "warning",
    showCancelButton,
    cancelButtonText: "No",
    confirmButtonColor: "#2e5965",
    cancelButtonColor: "#dd3333",
    confirmButtonText,
  }).then((result) => {
    callbackFunction(result.value);
  });
}